<div
  class="enfaf-img-dragger"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  (click)="triggerFileInput()"
  [class.dragover]="isDraggingOver"
  [ngStyle]="{minHeight: minHeight, minWidth: minWidth, width: width}"
>
  @if (imageToUploadSrc && imageToUploadSrc !== '') {
    <img [src]="imageToUploadSrc" alt="Imagen del curso" [style.object-fit]="objectFit" />
    <div class="delete" (click)="deleteImage($event)">
      <app-enfaf-icon svgIconName="trash-red" iconSize="21px" />
    </div>
    @if (isUploadingImage) {
      <div class="loader-overlay">
        <div class="loader"></div>
      </div>
    }
  } @else if (urlImage && urlImage !== '') {
    <img [src]="urlImage" alt="Imagen del curso" [style.object-fit]="objectFit" />
    <div class="delete" (click)="deleteImage($event)">
      <app-enfaf-icon svgIconName="trash-red" iconSize="21px" />
    </div>
    @if (isUploadingImage) {
      <div class="loader-overlay">
        <div class="loader"></div>
      </div>
    }
  } @else {
    @if (isUploadingImage) {
      <div class="loader-overlay">
        <div class="loader"></div>
      </div>
    } @else {
      <div class="content">
        <app-enfaf-icon svgIconName="image" iconSize="56px"></app-enfaf-icon>

        <div class="text-wrapper">
          <ng-content select="[slot-text]"></ng-content>

          <p class="text text-default">
            {{ title && title !== '' ? title : 'Imagen del curso'}}
            <br />
            {{ actionText }}
          </p>
        </div>
      </div>
    }
  }
</div>

<input type="file" #fileInput style="display: none" accept="image/*" (change)="onFileSelected($event)" />
